import { Product } from '../../../modules/product/models/Product'
import {
  emptyPatientCitogeneticaArrayDTO,
  fromPatientNGSModel,
  PatientCitogeneticaArrayDTO,
} from '../../../modules/patient/models/patientForm/PatientCitogeneticaArrayDTO'
import { useStyles } from '../Application.styles'
import { COLOR_PRIMARY } from '../../../routes/color-constants'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Button,
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import { FormType } from '../../../common/enums/Enums'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2'
import { PatientCitogeneticaArray } from '../../../modules/patient/models/patientForm/PatientCitogeneticaArray'
import { userGenders } from '../../../modules/users/enums/GenderType'
import { getPatientContainer } from 'container/patient-modules'
import { getClientContainer } from 'container/client-modules'
import { CLIENTS_SERVICE_KEY } from 'modules/clients'
import { PATIENT_SERVICE_KEY } from 'modules/patient'
import { ClientService } from 'modules/clients/services/ClientService'
import { PatientService } from 'modules/patient/services/PatientService'
import { Query, QueryParam } from 'common/api/Query'
import { SampleCitogenetica } from 'modules/sampleType/models/sampleForm/SampleCitogenetica'
import {
  emptySampleCitogeneticaDTO,
  toModel,
} from 'modules/sampleType/models/sampleForm/SampleCitogeneticaDTO'
import { emptySampleDTO } from 'modules/sample/models/SampleDTO'
import { v4 as uuidv4 } from 'uuid'
import { format, isValid } from 'date-fns'
import {convertTimeToLocal, formatDate } from '../../../common/utils/DataFormatters'

type RouteProps = {
  id?: string
  navigate?: () => void
}

export type FormCitogeneticaProps = RouteProps & {
  patients: PatientCitogeneticaArrayDTO[]
  productIndex: number
  handleChangePatients: (productIndex: number, patients: any[], type: FormType) => void
  product: Product
  type?: string
  edit?: boolean
  clientIDDoingTheRequest: string
  setIsOpen: (bool: boolean) => void
  setCurrentProduct: (curentProduct: number) => void
  setCurentType: (curentType: number) => void
}

const patientService = getPatientContainer().get<PatientService>(PATIENT_SERVICE_KEY)
const clientService = getClientContainer().get<ClientService>(CLIENTS_SERVICE_KEY)

export const PatientFormCitogeneticaArray = (props: FormCitogeneticaProps) => {
  const patientNumber = props.product.patientNumber || 0
  const classes = useStyles({ color: COLOR_PRIMARY })
  const [patients, setPatients] = useState<PatientCitogeneticaArrayDTO[]>(props.patients)
  const { t, i18n } = useTranslation()
  const [previousPatients, setPreviousPatients] = useState<any[]>([])
  const [selectedPatientID, setSelectedPatientID] = useState<string[]>([])

  useEffect(()=>{
    if (props.patients) setPatients(props.patients)
  },[props.patients])

  useEffect(() => {
    let patientsAux: PatientCitogeneticaArrayDTO[] = []
    let start = 0

    for (let i = start; i < patientNumber; i++) {
      if (props.patients[i]) {
          let filtered = previousPatients.filter((p)=> p.id == props.patients[i]._id)
          let auxSelected: any[] = []

          if (filtered?.length > 0) {
            if (patientNumber > 0) {
              auxSelected[0] = filtered[0].id
              patientsAux[0] = fromPatientNGSModel(filtered[0])
            }
    
            setSelectedPatientID(auxSelected)
          }
          patientsAux[i] = props.patients[i]
      } else {
        patientsAux[i] = emptyPatientCitogeneticaArrayDTO()
      }
    }

    setPatients(patientsAux)
  }, [previousPatients])

  useEffect(() => {
    if (props.patients?.length > 0) {
      let auxSelected: any[] = []
      props.patients.forEach((p, i) => {
        auxSelected[i] = p._id
      })
      setSelectedPatientID(auxSelected)
    } else {
      let auxSelected: any[] = []
      Array(patientNumber).forEach((_, i) => {
        auxSelected[i] = ''
      })
      setSelectedPatientID(auxSelected)
    }
  }, [])

  useEffect(() => {
    clientService.getByID(props.clientIDDoingTheRequest).subscribe(async (res) => {
      if (res) {
        let client = res

    let all = await patientService.getAllPatients(  new Query({
                  query: [new QueryParam('clientID', client.id || '')],
                })).toPromise()
      const resultArray = [...(all?.items) || []]
        let personasFiltradas: any[] = filtrarPersonas(resultArray)

        if (window.location.pathname.includes('new')) {
          personasFiltradas.forEach((persona) => {
            //@ts-ignore
            persona._sample = toModel(emptySampleDTO())
            //@ts-ignore
            persona.sample = toModel(emptySampleDTO())
          })
        }

        setPreviousPatients(personasFiltradas)
      }
    })
  }, [])

  function filtrarPersonas(personas: any[]): any[] {
    const personasFiltradas: { [key: string]: any } = {}

    personas.forEach((persona) => {
      if (personasFiltradas[persona.firstName + persona.lastName]) {
        if (persona.priority) {
          personasFiltradas[persona.firstName + persona.lastName] = persona
        }
      } else {
        personasFiltradas[persona.firstName + persona.lastName] = persona
      }
    })

    return Object.values(personasFiltradas)
  }

  const getEmptyPatients = (): PatientCitogeneticaArrayDTO[] => {
    const patients: PatientCitogeneticaArrayDTO[] = []
    if (patientNumber) {
      for (let i = 0; i < patientNumber; i++) {
        patients.push(emptyPatientCitogeneticaArrayDTO())
      }
    }
    return patients
  }

  useEffect(() => {  
    if (
      props.type != 'view' &&
      ((props.patients !== null && props.patients?.length == 0) || props.patients == null)
    ) {
      props.handleChangePatients(
        props.productIndex,
        getEmptyPatients(),
        FormType.TypeFormCitogeneticaArray
      )
    }
  }, [props.product])

  useEffect(() => {
    if (props.type == 'view') {
      props.handleChangePatients(
        props.productIndex,
        props.patients,
        FormType.TypeFormCitogeneticaArray
      )
    }
  }, [props.type])

  const handlePatientChange = (
    index: number,
    field: keyof PatientCitogeneticaArray,
    value: string | Date | boolean | number
  ) => {
    const newPatients = [...patients]
    const patientToUpdate = newPatients[index]
    const updatedPatient = { ...patientToUpdate, [field]: value }

    if (!updatedPatient._id) {
      updatedPatient._id = uuidv4()
    }

    newPatients[index] = updatedPatient

    setPatients(newPatients)
    props.handleChangePatients(props.productIndex, newPatients, FormType.TypeFormCitogeneticaArray)
  }

  const handleSetSelectedValue = (index: number, value: string) => {
    let patientsAux = previousPatients.filter((p) => p.id == value)
    const newPatients = [...patients]

    if (patientsAux?.length > 0) {
      let patient = patientsAux[0]

      let auxElement = {
        _id: patient.id,
        _firstName: patient.firstName,
        _lastName: patient.lastName,
        _dob: patient.dob,
        _nhc: patient.nhc,
        _sex: patient.sex?.toString(),
        _indication: patient.indication,
        _previousGeneticStudies: patient.previousGeneticStudies,
        _familyBackground: patient.familyBackground,
        _fetalSex: patient.fetalSex?.toString(),
        _eggDonationPregnancy: patient.eggDonationPregnancy,
        _weeksGestation: patient.weeksGestation,
        _sample: patient._sample
          ? patient._sample
          : patient.sample
          ? patient.sample
          : new SampleCitogenetica(emptySampleCitogeneticaDTO()),
      }

      newPatients.splice(index, 1, auxElement)
    } else {
      newPatients.splice(index, 1, emptyPatientCitogeneticaArrayDTO())
    }

    setPatients(newPatients)
    props.handleChangePatients(props.productIndex, newPatients, FormType.TypeFormCitogeneticaArray)

    let auxSelected = [...selectedPatientID]
    auxSelected[index] = value
    setSelectedPatientID(auxSelected)
  }

  const openModal = () => {
    props.setCurrentProduct(props.productIndex)
    props.setCurentType(FormType.TypeFormCitogeneticaArray)
    props.setIsOpen(true)
  }

  return (
    <Grid container direction="column">
      {[...Array(patientNumber)]?.map((_, index) => (
        <Grid container spacing={4} key={index} style={{ marginTop: '40px' }}>
          <Grid item xs={12} style={{ textAlign: 'left', fontWeight: 'bold', fontSize: '18px' }}>
            {t('fillPatientData') + ' ' + (index + 1) + ' ' + t('for') + ' ' + (i18n.language == "es" ? props.product.nameES : props.product.nameEN)}
          </Grid>
          {props.edit !== false && (
            <Grid item xs={12}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="typeSampleLabel">{t('selectPatient')}</InputLabel>
                <Select
                  labelId={'typeSampleLabel'}
                  id={'type'}
                  name={'type'}
                  //@ts-ignore
                  onChange={(e) => handleSetSelectedValue(index, e.target.value)}
                  style={{ width: '50%' }}
                  value={selectedPatientID?.length > index ? selectedPatientID[index] : ''}>
                  {previousPatients?.map((patient, indexST) => {
                    return (
                      <MenuItem key={indexST} value={patient.id}>
                        {patient.firstName + ' ' + patient.lastName}
                      </MenuItem>
                    )
                  })}
                  <MenuItem key={''} value={''}>
                    {t('notSelect')}
                  </MenuItem>
                </Select>
                
                {props.productIndex > 0 && (
                <Button
                  variant="contained"
                  onClick={openModal}
                  className={classes.button}
                  style={{ display: 'flex', alignSelf: 'flex-end' }}>
                  {t("aplyPatientes")}
                </Button>)
               }

              </FormControl>
            </Grid>
          )}
          <Grid item xs={6}>
            <TextField
              id={`firstName-${index}`}
              label={t('name')}
              variant="filled"
              fullWidth
              disabled={props.edit === false}
              className={classes.textField}
              value={(patients && patients[index]?._firstName) || ''}
              onChange={(e) => handlePatientChange(index, '_firstName', e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`lastName-${index}`}
              label={t('lastName')}
              variant="filled"
              fullWidth
              className={classes.textField}
              disabled={props.edit === false}
              value={(patients && patients[index]?._lastName) || ''}
              onChange={(e) => handlePatientChange(index, '_lastName', e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                format="dd/MM/yyyy"
                value={(patients && convertTimeToLocal(patients[index]?._dob)) || null}
                onChange={(date) => date && isValid(date) && handlePatientChange(index, '_dob', formatDate(date))}
                disabled={props.edit === false}
                label={t('dob')}
                slotProps={{
                  textField: {
                    variant: 'outlined',
                    size: 'small',
                    required: true,
                    sx: { width: '100%' },
                    id: `dob-${index}`,
                  }
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <InputLabel id="inherit-label">{t('gender')+"*"}</InputLabel>
              <Select
                labelId="gender-label"
                id="gender"
                fullWidth={props.edit === false}
                style={{ textAlign: 'left' }}
                value={(patients && patients[index]?._sex) || ''}
                onChange={(e) => handlePatientChange(index, '_sex', e.target.value as string)}
                required
                label={t('gender')}>
                {Object.entries(userGenders())?.map(([key, value]) => (
                  <MenuItem value={key}>{value}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id={`nhc-${index}`}
              label={t('nhc')}
              variant="filled"
              disabled={props.edit === false}
              fullWidth
              className={classes.textField}
              value={(patients && patients[index]?._nhc) || ''}
              onChange={(e) => handlePatientChange(index, '_nhc', e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id={`indication-${index}`}
              disabled={props.edit === false}
              label={t('indication')}
              onChange={(event) => handlePatientChange(index, '_indication', event.target.value)}
              multiline
              rows={4}
              value={(patients && patients[index]?._indication) || ''}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id={`previousGeneticStudies-${index}`}
              disabled={props.edit === false}
              label={t('previousGeneticStudies')}
              onChange={(event) =>
                handlePatientChange(index, '_previousGeneticStudies', event.target.value)
              }
              multiline
              rows={4}
              value={(patients && patients[index]?._previousGeneticStudies) || ''}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id={`familyBackground-${index}`}
              label={t('familyBackground')}
              disabled={props.edit === false}
              onChange={(event) =>
                handlePatientChange(index, '_familyBackground', event.target.value)
              }
              multiline
              rows={4}
              value={(patients && patients[index]?._familyBackground) || ''}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item xs={12} style={{ textAlign: 'left', fontWeight: 'bold', fontSize: '18px' }}>
            {t('inCaseOfPrenatal')}
          </Grid>

          <Grid container spacing={4} key={index}>
            <Grid item xs={12} style={{ marginLeft: '1%', marginRight: '1%' }}>
              <FormControl fullWidth variant="outlined">
                <InputLabel id="inherit-label">{t('fetalSex')}</InputLabel>
                <Select
                  labelId="gender-label"
                  id="fetalSex"
                  fullWidth
                  disabled={props.edit === false}
                  style={{ textAlign: 'left' }}
                  value={(patients && patients[index]?._fetalSex) || ''}
                  onChange={(e) =>
                    handlePatientChange(index, '_fetalSex', e.target.value as string)
                  }
                  label={t('fetalSex')}>
                  {Object.entries(userGenders()).map(([key, value]) => (
                    <MenuItem value={key}>{value}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} style={{ marginLeft: '1%', marginRight: '1%' }}>
              <Grid container spacing={1}>
                <Grid item xs={2}>
                  {t('eggDonationPregnancy')}
                </Grid>
                <Grid item xs={3}>
                  <Checkbox
                    checked={patients && patients[index]?._eggDonationPregnancy == true}
                    onChange={() => handlePatientChange(index, '_eggDonationPregnancy', true)}
                    color="primary"
                    disabled={props.edit === false}
                  />
                  {t('yes')}
                </Grid>
                <Grid item xs={4}>
                  <Checkbox
                    checked={patients && patients[index]?._eggDonationPregnancy == false}
                    onChange={() => handlePatientChange(index, '_eggDonationPregnancy', false)}
                    color="primary"
                    disabled={props.edit === false}
                  />
                  {t('no')}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ marginLeft: '1%', marginRight: '1%' }}>
              <TextField
                id={`weeksGestation-${index}`}
                label={t('weeksGestation')}
                variant="filled"
                fullWidth
                type={'number'}
                value={(patients && patients[index]?._weeksGestation) || 0}
                onChange={(e) =>
                  handlePatientChange(index, '_weeksGestation', parseFloat(e.target.value))
                }
                inputProps={{ min: 0 }}
                disabled={props.edit === false}
              />
            </Grid>
          </Grid>
        </Grid>
      ))}
    </Grid>
  )
}
